import { getMessage } from '../../components';

export default messages => {
    return {
        gatewayType: {
            identifier: 'gatewayType',
            required: true,
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.gatewayType')
            },
            optionLabel: {
                payPal: getMessage(messages, 'epic.esport.label.payoutInfo.gatewayType.Paypal'),
                bank: getMessage(messages, 'epic.esport.label.payoutInfo.gatewayType.bank')
            }
        },
        payPal: {
            identifier: 'accountEmail',
            required: true,
            validations: {
                isEmail: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isEmail: getMessage(messages, 'errors.epic.validation.email')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.paypal_email')
            }
        },
        foreignBank: {
            identifier: 'foreignBank',
            required: true,
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.foreignBank')
            },
            optionLabel: {
                yes: getMessage(messages, 'epic.esport.label.payoutInfo.foreignBank.yes'),
                no: getMessage(messages, 'epic.esport.label.payoutInfo.foreignBank.no')
            }
        },
        checkName: {
            identifier: 'checkName',
            required: true,
            validations: {
                maxLength: 64
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.checkName'), '64'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.checkName')
            }
        },
        bankName: {
            identifier: 'bankName',
            required: true,
            validations: {
                maxLength: 128
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.bankName'), '128'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.bankName')
            }
        },
        routingNo: {
            identifier: 'routingNo',
            required: true,
            validations: {
                maxLength: 32,
                isNumeric: true,
                validRoutingNumber: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.routingNo'), '32']),
                isNumeric: getMessage(messages, 'errors.epic.validation.must.number'),
                validRoutingNumber: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.routingNo')])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.routingNo'),
                toolTip: getMessage(messages, 'epic.esport.bank.form.popover')
            }
        },
        bankAccountNo: {
            identifier: 'bankAccountNo',
            required: true,
            validations: {
                maxLength: 42,
                isValidBandAccountNo: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.bankAccountNo'), '42']),
                isValidBandAccountNo: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.bankAccountNo')])
            },
            display: {
                text_bankAccountNo: getMessage(messages, 'epic.esport.label.payoutInfo.bankAccountNo'),
                text_IBAN: getMessage(messages, 'epic.esport.label.payoutInfo.IBAN')
            }
        },
        swiftCode: {
            identifier: 'swiftCode',
            required: true,
            validations: {
                maxLength: 32,
                isValidSwiftCode: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.swiftCode'), '32']),
                isValidSwiftCode: getMessage(messages, 'errors.epic.validation.valied', [getMessage(messages, 'epic.esport.label.payoutInfo.swiftCode')])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.swiftCode')
            }
        },
        accountDetails: {
            identifier: 'additionalAccountDetail',
            validations: {
                maxLength: 1024
            },
            validationMessages: {
                maxLength: getMessage(messages, 'errors.epic.validation.maxLength', [getMessage(messages, 'epic.esport.label.payoutInfo.additionalAccountDetail'), '1024'])
            },
            display: {
                text: getMessage(messages, 'epic.esport.label.payoutInfo.additionalAccountDetail')
            }
        }
    };
};
